import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=0d36fa0c&scoped=true&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"
import style0 from "./Services.vue?vue&type=style&index=0&id=0d36fa0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d36fa0c",
  null
  
)

export default component.exports